module.exports = __webpack_public_path__ + "static/media/Hugfimi-fill-side.ac5709da.png";